import { render } from "./TemplateEditComponent.vue?vue&type=template&id=180121ae&scoped=true"
import script from "./TemplateEditComponent.vue?vue&type=script&lang=js"
export * from "./TemplateEditComponent.vue?vue&type=script&lang=js"

import "./TemplateEditComponent.vue?vue&type=style&index=0&id=180121ae&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180121ae"]])

export default __exports__